module.exports = __webpack_public_path__ + "static/media/yeutech_letter-template.8264fde5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/static/yeutech_letter-template.jpeg
// module id = 245
// module chunks = 0